import { Text, Stack } from "@chakra-ui/react";
import { KYDMetric } from "@common/interfaces/KYDOrganization";

import {
  BarChart,
  Bar,
  ResponsiveContainer,
  XAxis,
  YAxis,
  Tooltip,
  LineChart,
  Line,
} from "recharts";

export const PageViews = (props: { eventMetrics: KYDMetric[] }) => {
  return (
    <Stack
      width={"100%"}
      height={props.eventMetrics.length > 0 ? "200px" : "85px"}
      spacing={4}
    >
      <Text
        w="100%"
        textAlign="left"
        color="black"
        fontSize={"xl"}
        fontWeight="bold"
      >
        Page Views
      </Text>
      {props.eventMetrics.length > 0 ? (
        <ResponsiveContainer>
          <LineChart data={props.eventMetrics}>
            <Tooltip
              cursor={{ fill: "#eee" }}
              labelStyle={{ color: "black" }}
            />
            <Line
              name="Page Views"
              type="monotone"
              dataKey="count"
              stroke="#000"
              strokeWidth={"2px"}
            />
            <XAxis dataKey="date" interval="preserveStartEnd" />
            <YAxis
              tickFormatter={(value, index) => {
                const formatter = new Intl.NumberFormat("en-US", {
                  notation: "compact",
                });
                return formatter.format(value);
              }}
              allowDecimals={false}
            />
          </LineChart>
        </ResponsiveContainer>
      ) : (
        <Text color="gray.500">No page view data to display yet</Text>
      )}
    </Stack>
  );
};
